import React, { useState, useEffect, useRef } from "react";
//import { Row, Col } from 'reactstrap';
import { withStyles } from '@material-ui/core';
import * as Constants from '../../Pages/Constants';
import { FormattedMessage } from 'react-intl';
import { Row, Col, Card } from 'antd'

import 'react-phone-number-input/style.css'
import PhoneInput, {isValidPhoneNumber} from 'react-phone-number-input'

const AddPhoneNumberPopup = (props) => {

  const { classes } = props;

  const [displayValidationPopup, setDisplayValidationPopup] = useState(false);
  const [number, setNumber] = useState("");

  const handleValidationPopupDisplay = () => {
    setDisplayValidationPopup(!displayValidationPopup)
  }

  const handleNewPhoneNumber = () => {
    let number_list = [...props.smsalert]
    if (number_list[0] === "") {
      number_list = [number]
    }
    else {
    number_list.push(number);
    }
    props.setSmsalert(number_list);
    props.setChangeOngoing(true);
    props.setDisplayAddPhoneNumberPopup(false);
  }

  const handleChangeNumber = (event) => {
    if (event === undefined) {
      setNumber("")
    }
    else {
      setNumber(event)
    }
  }

  return (
    <div className={classes.popup_background}>
      <div style={{ width:"75%", height: "100%", display: "flex", flexDirection: "column", justifyContent: "center"}}>
        <div className="submit-form" style={{ borderRadius: "5px"}}>
          <Row style={{ fontWeight: "bold", fontSize:"2.2em"}}>
              <FormattedMessage id="popup.phonenumber.title" defaultMessage="Add phone number"/>
          </Row>
          <br/>
          <PhoneInput placeholder="Enter phone number" onChange={handleChangeNumber}/>
          <br/>
          <br/>
          <button onClick={props.cancelPopup} className="btn btn-danger">
            <FormattedMessage id="button.cancel" defaultMessage="Cancel" />
          </button>
          <button onClick={handleNewPhoneNumber} className="btn btn-success" disabled={!isValidPhoneNumber(number)}>
            <FormattedMessage id="button.submit" defaultMessage="Submit" />
          </button>
        </div>
      </div>
    </div>
  );
}

export default withStyles(Constants.styles)(AddPhoneNumberPopup);
